import React from 'react';
import cls from 'classnames';

import { FullSheetProps } from './FullSheet.types';
import { useSheet } from '../../../utilities/useSheet';
import StickyBoxSheet from '../StickyBoxSheet';

const FullSheet: React.FC<FullSheetProps> = (props) => {
	const {
		navLayout,
		mainLayout,
		legalLayout,
		buttonLayout,
		onClose,
		isDismissable = true,
	} = props;
	const { isClosing, closeSheet } = useSheet({
		onClose,
		animationTimeout: 125,
	});

	return (
		<div
			className={cls('full-sheet', { isClosing })}
			// aria-hidden="true"
			// aria-labelledby="my-dialog-title"
			data-testid={props['data-testid']}
			role="dialog"
		>
			{/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
			<div
				className="full-sheet-overlay"
				onClick={isDismissable ? closeSheet : undefined}
			/>
			<div className="full-sheet-content" role="document">
				<div className="full-sheet-nav">{navLayout?.({ closeSheet })}</div>
				<div className="full-sheet-main">
					{mainLayout}
					{(!!legalLayout || !!buttonLayout) && (
						<StickyBoxSheet
							legalLayout={legalLayout}
							buttonLayout={buttonLayout && buttonLayout({ closeSheet })}
						/>
					)}
				</div>
			</div>
		</div>
	);
};

FullSheet.displayName = 'FullSheet';

export default FullSheet;
